export default __webpack_public_path__ + "static/media/humanist-777-bold-bt.021966e5.ttf";